import { render, staticRenderFns } from "./FormButton.vue?vue&type=template&id=65aae714"
import script from "./FormButton.vue?vue&type=script&lang=js"
export * from "./FormButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports